import React from 'react';
import { Button, Modal } from 'antd';
import type { EmailExclusionJob } from './types';
import ViewEmailExclusionJobModalContent from './ViewEmailExclusionJobModalContent';

type Props = {
  job: EmailExclusionJob,
};

export default function ViewExclusionJobDetailsButton(props: Props) {
  const [visible, setVisible] = React.useState(false);
  return (
    <>
      <Button icon="eye" onClick={() => setVisible(true)}>
        Details
      </Button>
      <Modal
        okButtonProps={{
          onClick: () => setVisible(false),
        }}
        title="Exclusion Job Details"
        visible={visible}
        width={800}
        onCancel={() => setVisible(false)}
      >
        <ViewEmailExclusionJobModalContent job={props.job} />
      </Modal>
    </>
  );
}
